import script from "./powerStationVideoScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./powerStationVideoScreen.vue?vue&type=script&setup=true&lang=js"

import "./powerStationVideoScreen.vue?vue&type=style&index=0&id=158660ef&lang=less"

const __exports__ = script;

export default __exports__